<template>
    <div class="head">
      <div class="head-left">
        <div class="head-name">
          <div class="user-icon" v-if="isToken">
            <span>{{username}}</span>
            <span>{{$t('navs.betNum')}}：<em>{{betquota}}</em></span>
          </div>
          <div class="user-balance" v-if="isToken"><span style="padding-right: 5px">{{$t('login.amount')}}</span>{{balance}}</div>
          <div class="home-roll">
            <marquee width="100%" behavior="scroll" direction="left">
              <span v-for="item in notice" v-html="item.content"></span>
            </marquee>
          </div>
        </div>

      </div>
      <div class="home-right">
        <lang></lang>
        <div class="home-right-notice" v-if="isToken==true" @click.stop="_clickUrl(3)"></div>
        <div class="icon-hamburger" @click.stop="_openUrl"></div>

      </div>
      <div class="menu-left" v-if="isHead">
        <div v-if="this.$route.name!='home'" @click.stop="_clickUrl(1)">{{$t('home.index')}}</div>
        <div @click.stop="_clickUrl(2)">{{$t('home.account')}}</div>
        <div @click.stop="_clickUrl(7)">{{$t('home.app')}}</div>
        <div @click.stop="_clickUrl(4)">{{$t('home.record')}}</div>
        <div @click.stop="_hidePaw(3)">{{$t('loginPaw.t_11')}}</div>
        <!--<div @click.stop="_hidePaw(4)" v-if="set_withdraw_password==1">{{$t('loginPaw.t_10')}}</div>-->
        <div @click.stop="_hidePaw(2)" v-if="set_withdraw_password==0">{{$t('loginPaw.t_12')}}</div>
        <div @click.stop="_clickUrl(8)">{{$t('Online.title')}}</div>
        <div v-if="isToken==true" @click.stop="_clickUrl(5)">{{$t('home.exit')}}</div>
        <div v-if="isToken==false" @click.stop="_clickUrl(6)">{{$t('home.signIn')}}</div>
      </div>
      <div class="headCover" v-if="isPaw==1"><!--设置支付密码-->
        <div class="coverCenter">
          <div class="coverCenter-title">{{$t('loginPaw.t_12')}}<span @click.stop="_hidePaw(1)"><img src="../../assets/img/close.png"/></span></div>
          <div class="cover-input">
            <span>{{$t('loginPaw.t_13')}}:</span>
            <input type="text" :placeholder="$t('loginPaw.t_14')" v-model="setPay.cash_password"/>
          </div>
          <div class="cover-input">
            <span>{{$t('loginPaw.t_4')}}:</span>
            <input type="text" :placeholder="$t('loginPaw.t_7')" v-model="setPay.cash_password_confirmation"/>
          </div>
          <div class="cover-submit" @click.stop="_setPay">{{$t('loginPaw.t_8')}}</div>
        </div>
      </div>
      <div class="headCover" v-if="isPaw==2"><!--修改登录密码-->
        <div class="coverCenter">
          <div class="coverCenter-title">{{$t('loginPaw.title')}}<span @click.stop="_hidePaw(1)"><img src="../../assets/img/close.png"/></span></div>
          <div class="cover-input">
            <span>{{$t('loginPaw.t_2')}}:</span>
            <input type="text" :placeholder="$t('loginPaw.t_5')" v-model="old_password"/>
          </div>
          <div class="cover-input">
            <span>{{$t('loginPaw.t_3')}}:</span>
            <input type="text" :placeholder="$t('loginPaw.t_6')" v-model="password"/>
          </div>
          <div class="cover-input">
            <span>{{$t('loginPaw.t_4')}}:</span>
            <input type="text" :placeholder="$t('loginPaw.t_7')" v-model="password_confirmation"/>
          </div>
          <div class="cover-submit" @click.stop="_password(0)">{{$t('loginPaw.t_8')}}</div>
        </div>
      </div>
      <div class="headCover" v-if="isPaw==3"><!--修改支付密码-->
        <div class="coverCenter">
          <div class="coverCenter-title">{{$t('loginPaw.t_9')}}<span @click.stop="_hidePaw(1)"><img src="../../assets/img/close.png"/></span></div>
          <div class="cover-input">
            <span>{{$t('loginPaw.t_2')}}:</span>
            <input type="text" :placeholder="$t('loginPaw.t_5')" v-model="old_password"/>
          </div>
          <div class="cover-input">
            <span>{{$t('loginPaw.t_3')}}:</span>
            <input type="text" :placeholder="$t('loginPaw.t_6')" v-model="password"/>
          </div>
          <div class="cover-input">
            <span>{{$t('loginPaw.t_4')}}:</span>
            <input type="text" :placeholder="$t('loginPaw.t_7')" v-model="password_confirmation"/>
          </div>
          <div class="cover-submit" @click.stop="_password(1)">{{$t('loginPaw.t_8')}}</div>
        </div>
      </div>





    </div>
</template>

<script>
  import lang from '../navs/lang'
    export default {
        name: "headr",
      components:{lang},
      data(){
          return{
            isHead:false,
            notice:[],
            isToken:false,
            username:'',
            balance:'',
            phone:'',
            betquota:'',
            intervalId:null,
            isPaw:0,
            setPay:{
              cash_password:'',
              cash_password_confirmation:'',
            },
            isSubmit:false,
            set_withdraw_password:0,
            password_confirmation:'',
            old_password:'',
            password:'',
          }
      },
      created:function(){
          let _self=this;
          _self._notice();
          _self._user();
          _self.dataRefreh();
          let token=_self.GLOBAL.fetch('token');
          if(token.length!=0){
            _self._userConfig();

          }else{
            _self.clear();

          }
      },
      destroyed(){
        // 在页面销毁后，清除计时器
        this.clear();
      },
      methods:{
        _userConfig:function(){
          let _self=this;
          this._PublicFun.getData('2', 'get', 'user/config', {}, function (result) {
            if(result.data['status_code']==200){
              _self.set_withdraw_password=result.data['data'].set_withdraw_password;

            }
          })
        },
        _hidePaw:function(m){
          let _self=this;
          if(m==1){
            _self.isPaw=0;
          }else{
            let token=_self.GLOBAL.fetch('token');
            if(token.length!=0){
              if(m==2){
                _self.isPaw=1;
              }else if(m==3){
                _self.isPaw=2;
              }else if(m==4){
                _self.isPaw=3;
              }
            }else{
              Toast(_self.$t('home.login'));
              _self.$router.push({path:'/Login'})
            }
          }


        },
        _setPay:function(){
          let _self=this;
          if(_self.setPay.cash_password_confirmation!='' && _self.setPay.cash_password!=''){
            if(_self.setPay.cash_password==_self.setPay.cash_password_confirmation){
              if(_self.isSubmit)
                return false;
              _self.isSubmit=true;
              this._PublicFun.getData('2', 'post', 'user/cash_password', {'cash_password':_self.setPay.cash_password,'cash_password_confirmation':_self.setPay.cash_password_confirmation}, function (result) {
                if(result.data['status_code']==200){
                  _self.isPaw=0;
                  _self.set_withdraw_password=1;
                  _self.setPay.cash_password='';
                  _self.setPay.cash_password_confirmation='';
                  _self.isSubmit=false;
                  Toast(_self.$t('loginPaw.t_18'));
                }else{
                  Toast(result.data['message']);
                  _self.isSubmit=false;
                }

              })
            }else{
              Toast(_self.$t('loginPaw.t_16'))
            }
          }else{
            Toast(_self.$t('loginPaw.t_15'))
          }

        },
        _password:function (type) {
          let _self=this;
          if(_self.isSubmit)
            return false;
          _self.isSubmit=true;
          if(_self.old_password!='' && _self.password!='' && _self.password_confirmation!=''){
            if(_self.password==_self.password_confirmation){
              this._PublicFun.getData('2', 'put', 'user/old_password', {'old_password':_self.old_password,'type':type,'password':_self.password,'password_confirmation':_self.password_confirmation}, function (result) {
                if(result.data['status_code']==200){
                  Toast(_self.$t('loginPaw.t_17'));
                  _self.isSubmit=false;
                  _self.old_password='';
                  _self.password_confirmation='';
                  _self.password='';
                  _self.isPaw=0;
                }else{
                  Toast(result.data['message']);
                  _self.isSubmit=false;
                }
              })
            }else{
              Toast(_self.$t('loginPaw.t_16'));
            }
          }else{
            Toast(_self.$t('loginPaw.t_15'));
          }

        },
        _user:function () {
          let _self=this;
          let token=_self.GLOBAL.fetch('token');
          if(token.length!=0){
            this._PublicFun.getData('2', 'get', 'user', {}, function (result) {
              if(result.data['status_code']==200){
                _self.GLOBAL.save('user',result.data['data']);
                _self.username=result.data['data'].username;
                _self.balance=result.data['data'].balance;
                _self.phone=result.data['data'].phone;
                _self.betquota=result.data['data'].withdraw_bet_quota;
                _self.isToken=true;
              }

            })
          }else{
            _self.clear();
            _self.isToken=false;
          }
        },
        dataRefreh() {
          // 计时器正在进行中，退出函数
          if (this.intervalId != null) {
            return;
          }
          // 计时器为空，操作
          this.intervalId = setInterval(() => {
            this._user();
          }, 5000);
        },
        // 停止定时器
        clear() {
          clearInterval(this.intervalId); //清除计时器
          this.intervalId = null; //设置为null
        },
        _openUrl:function(m){
          let _self=this;
          if(_self.isHead==true){
            _self.isHead=false;
          }else{
            _self.isHead=true;
          }
        },
        _clickUrl:function(m){
          let _self=this;
          if(m==1){
            _self.$router.push({path:'/'})
          }else if(m==5){
            _self.GLOBAL.delete('token');
            _self.GLOBAL.delete('user');
            _self.isToken=false;
            _self.isHead=false;
          }else if(m==6){
            _self.$router.push({path:'/Login'})
          }else if(m==7){
            _self.$router.push({path:'/download'})

          }else if(m==8){
            _self.$router.push({path:'/messenger'})
          }else{
            let token=_self.GLOBAL.fetch('token');
            if(token.length!=0){
              let url='';
              if(m==2){
                url='/account'
              }else if(m==3){
                url='/message'
              }else if(m==4){
                url='/record'
              }
              if(_self.$route.path!=url){
                _self.$router.push({path:url})
              }
            }else{
              Toast(_self.$t('home.login'));
              _self.$router.push({path:'/Login'})
            }
          }
        },
        _notice:function(){
          let _self=this;
          this._PublicFun.getData('1', 'get', 'article/5', {}, function (result) {
            if(result.data['status_code']==200){
              _self.notice=result.data['data'];
            }
          })
        },
      }
    }
</script>

<style scoped>
  .head{
    display: flex;
    width: 100%;
    margin: 0 auto;
    padding: 0;
    height: 45px;
    background-image: linear-gradient(-180deg, #0C1117 0%, #162C3F 100%);
    position: relative;
    align-items: center;
  }
  .head-left{
    width: calc(100% - 180px);
    display: flex;
    align-items: center;
  }
  .head-name{
    display: flex;
    align-items: center;
  }
  .user-icon{
    display: block;
    position: relative;
    padding-left: 40px;
  }
  .user-icon:before{
    background-image: url("../../assets/img/icon-id.svg");
    position: absolute;
    display: inline-block;
    left: 8px;
    top: 6px;
    content: '';
    width: 20px;
    height: 20px;
    background-size: cover;
  }
  .user-icon span{
    display: block;
    margin: 0;
    padding: 0;
    font-size: 14px;
    white-space: nowrap
  }
  .user-icon span:first-child{
    color: #F4E0BD;
  }
  .user-icon span:nth-child(2){
    display: block;
    background: #0b1218;
    border-radius: 100px;
    padding: 0 5px;
    margin-left: 0;
    font-size: 10px;
    color: #DBB069;
    width: 100%;
    text-align: left;
  }
  .user-icon span:nth-child(2) em{
    color: #ffffff;
    font-size: 13px;
  }
  .user-balance{
    display: block;
    margin: 0 auto;
    padding: 0 20px;
    color: #F4E0BD;
  }
  .home-roll{
    position: relative;
    overflow: hidden;
    width: 100%;
    color: #DBB069;
    display: flex;
    flex-wrap: nowrap;
  }
  .home-right{
    width: auto;
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    height: auto;
    align-items: unset;
    background-image: linear-gradient(-180deg, #0C1117 0%, #162C3F 100%)
  }
  .home-right-notice{
    background-image: url(../../assets/img/icon-inbox.svg);
    text-align: center;
    background-repeat: no-repeat;
    background-position: center;
    min-width: 50px;
    margin-left: 5px;
  }
  .icon-hamburger{
    font-size: 30px;
    line-height: 45px;
    color: #dbaa76 ;
    font-weight: bold;
    padding: 0 5px;
    cursor: pointer;
    margin-left: 5px;
  }
  .icon-hamburger:before{
    content: "\e923";
  }
  .menu-left{
    box-shadow: 0 0.2rem 0.2rem 0 rgba(108,131,172,0.5);
    position: absolute;
    right: 0;
    width: 320px;
    z-index: 800;
    top: 45px;
    background-color: #09141F;
  }
  .menu-left div{
    display: flex;
    width: 100%;
    align-items: center;
    padding: 12px 0;
    word-wrap: break-word;
    color: #EDD4AC;
    white-space: nowrap;
    cursor: pointer;
    text-indent: 2rem;
  }
  .menu-left div:hover{
    background-image: linear-gradient(-180deg, #2D465F 0%, #142531 47%, #0B1720 49%, #162F42 100%);
  }
  .headCover{
    position: fixed;
    z-index: 999;
    left: 0;
    width: 100%;
    top: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.3);
  }
  .coverCenter{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80%;
    max-width:450px;
    transform: translate(-50%,-50%);
    background-color: #ffffff;
    border-radius: 5px;
  }
  .coverCenter-title{
    display: block;
    width: 100%;
    margin: 0 auto;
    padding: 10px 0;
    text-align: center;
    border-bottom: 1px solid #dcdcdc;
    position: relative;
  }
  .coverCenter-title span{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 10px;
    cursor: pointer;
  }
  .coverCenter-title img{
    width: 30px;
    height: auto;
  }
  .cover-input{
    display: flex;
    width: 90%;
    margin: 0 auto;
    height: 45px;
    line-height: 45px;
    font-size: 18px;
    padding: 10px 0;
    align-items: center;
    border-bottom: 1px solid #dcdcdc;
  }
  .cover-input span:first-child{
    display: block;
    width: 120px;
    margin: 0;
    padding: 0;
    overflow: hidden;
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .cover-input input{
    display: block;
    width: 80%;
    margin: 0;
    padding: 0;
    height: 45px;
    line-height: 45px;
    border: none;
    font-size: 18px;
    outline: none;
  }
  .cover-submit{
    display: block;
    width: 80%;
    margin: 20px auto;
    padding: 0;
    height: 50px;
    line-height: 50px;
    background-color: #1A1A17;
    border-radius: 25px;
    color: #ffffff;
    text-align: center;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/navs/headr.vue